import React, { useEffect, useState, useRef, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, useMap, Popup } from 'react-leaflet';
import { Button, TextField, Container, Typography, Box, MenuItem, FormControlLabel, 
  Checkbox, Select, Grid, CircularProgress } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import { useImmerReducer } from 'use-immer'; // Import useImmerReducer if you're using immer
import Cookies from "js-cookie";
import api from '../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import axios from 'axios';

function AddProperty() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const areaCouncilOptions = [
    { value: '', label: ''},
    { value: 'Abaji', label: 'Abaji' },
    { value: 'AMAC', label: 'AMAC' },
    { value: 'Bwari', label: 'Bwari' },
    { value: 'Gwagwalada', label: 'Gwagwalada' },
    { value: 'Kuje', label: 'Kuje' },
    { value: 'Kwali', label: 'Kwali' },
  ]

  const abajiOptions = [
    { value: '', label: '' },
    { value: 'Abaji Town', label: 'Abaji Town' },
    { value: 'Agyana/Pandagi', label: 'Agyana/Pandagi' },
    { value: 'Alu/Mamagi', label: 'Alu/Mamagi' },
    { value: 'Ebagi', label: 'Ebagi' },
    { value: 'Gawu', label: 'Gawu' },
    { value: 'Nuku', label: 'Nuku' },
    { value: 'Rimba Ebagi', label: 'Rimba Ebagi' },
    { value: 'Sabon-Gari', label:  'Sabon-Gari' },
  ]

  const amacOptions = [
    { value: '', label: ''},
    { value: 'Apo', label: 'Apo' },
    { value: 'Asokoro', label: 'Asokoro' },
    { value: 'Durumi', label: 'Durumi' },
    { value: 'Garki', label: 'Garki' },
    { value: 'Guzape', label: 'Guzape' },
    { value: 'Gwarinpa', label: 'Gwarinpa' },
    { value: 'Jabi', label: 'Jabi' },
    { value: 'Jikwoyi', label: 'Jikwoyi' },
    { value: 'Karshi', label: 'Karshi' },
    { value: 'Karu', label: 'Karu' },
    { value: 'Kaura', label: 'Kaura' },
    { value: 'Lugbe', label: 'Lugbe' },
    { value: 'Maitama', label: 'Maitama' },
    { value: 'Mpape', label: 'Mpape' },
    { value: 'Nyanya', label: 'Nyanya' },
    { value: 'Utako', label: 'Utako' },
    { value: 'Wuse', label: 'Wuse' },
    { value: 'Wuye', label: 'Wuye' },
  ]

  const bwariOptions = [
    { value: '', label: ''},
    { value: 'Byazhin', label: 'Byazhin' },
    { value: 'Bwari Town', label: 'Bwari Town' },
    { value: 'Dei-Dei', label: 'Dei-Dei' },
    { value: 'Dutse', label: 'Dutse' },
    { value: 'Dutse Alhaji', label: 'Dutse Alhaji' },
    { value: 'Igu', label: 'Igu' },
    { value: 'Kawu', label: 'Kawu' },
    { value: 'Kogo', label: 'Kogo' },
    { value: 'Kubwa', label: 'Kubwa' },
    { value: 'Shere', label: 'Shere' },
    { value: 'Ushafa', label: 'Ushafa' },
    { value: 'Zuba', label: 'Zuba' },
  ]

  const gwagwaladaOptions = [
    { value: '', label: ''},
    { value: 'Dobi', label: 'Dobi' },
    { value: 'Giri', label: 'Giri' },
    { value: 'Gwako', label: 'Gwako' },
    { value: 'Gwagwalada Town', label: 'Gwagwalada Town' },
    { value: 'Ikwa', label: 'Ikwa' },
    { value: 'Kutunku', label: 'Kutunku' },
    { value: 'Paikon-Kore', label: 'Paikon-Kore' },
    { value: 'Tunga Maje', label: 'Tunga Maje' },
  ]

  const kujeOptions = [
    { value: '', label: ''},
    { value: 'Chibiri', label: 'Chibiri' },
    { value: 'Gaube', label: 'Gaube' },
    { value: 'Gudunkarya', label: 'Gudunkarya' },
    { value: 'Gwargwada', label: 'Gwargwada' },
    { value: 'Kuje Town', label: 'Kuje Town' },
    { value: 'Kwaku', label: 'Kwaku' },
    { value: 'Rubochi', label: 'Rubochi' },
    { value: 'Yangoji', label: 'Yangoji' },
  ]

  const kwaliOptions = [
    { value: '', label: ''},
    { value: 'Ashara', label: 'Ashara' },
    { value: 'Dafa', label: 'Dafa' },
    { value: 'Gumbo', label: 'Gumbo' },
    { value: 'Kilankwa', label: 'Kilankwa' },
    { value: 'Kundu', label: 'Kundu' },
    { value: 'Kwali Town', label: 'Kwali Town' },
    { value: 'Pai', label: 'Pai' },
    { value: 'Sheda', label: 'Sheda' },
    { value: 'Wako', label: 'Wako' },
    { value: 'Yangoji', label: 'Yangoji' },
  ]

  const initialState = {
    titleValue: "",
    descriptionValue: "",
    areaCouncilValue: "",
    districtValue: "",
    latitudeValue: "",
    longitudeValue: "",
    listingTypeValue: "",
    propertyStatusValue: "",
    rentalFrequencyValue: "",
    priceValue: "",
    roomsValue: "",
    furnishedValue: false,
    poolValue: false,
    elevatorValue: false,
    parkingValue: false,
    cctvValue: false,
    picture1Value: "",
    picture2Value: "",
    picture3Value: "",
    picture4Value: "",
    picture5Value: "",
    mapInstance: null,
    markerPosition: {
     lat: '9.0765', 
     lng: '7.3986',
    },
    uploadedPictures: [],
    sendRequest: 0,
    userProfile: {
      agencyName: "",
      phoneNumber: "",
    },
    userIsLogged: false,  // Track login status
  };

  function ReducerFunction(draft, action) {
    switch (action.type) {
      case "catchTitleChange":
        draft.titleValue = action.titleChosen;
        break;
      case "catchDescriptionChange":
        draft.descriptionValue = action.descriptionChosen;
        break;
      case "catchAreaCouncilChange":
        draft.areaCouncilValue = action.areaCouncilChosen;
        break;
      case "catchDistrictChange":
        draft.districtValue = action.districtChosen;
        break;
      case "catchLatitudeChange":
        draft.latitudeValue = action.latitudeChosen;
        break;
      case "catchLongitudeChange":
        draft.longitudeValue = action.longitudeChosen;
        break;
      case "catchListingTypeChange":
        draft.listingTypeValue = action.listingTypeChosen;
        break;
      case "catchPropertyStatusChange":
        draft.propertyStatusValue = action.propertyStatusChosen;
        break;
      case "catchRentalFrequencyChange":
        draft.rentalFrequencyValue = action.rentalFrequencyChosen;
        break;
      case "catchPriceValueChange":
        draft.priceValue = action.priceChosen;
        break;
      case "catchRoomsValueChange":
        draft.roomsValue = action.roomsChosen;
        break;
      case "catchFurnishedChange":
        draft.furnishedValue = action.furnishedChosen;
        break;
      case "catchPoolChange":
        draft.poolValue = action.poolChosen;
        break;
      case "catchElevatorChange":
        draft.elevatorValue = action.elevatorChosen;
        break;
      case "catchParkingChange":
        draft.parkingValue = action.parkingChosen;
        break;
      case "catchCctvChange":
        draft.cctvValue = action.cctvChosen;
        break;
      case "catchPicture1Change":
        draft.picture1Value = action.picture1Chosen;
        break;
      case "catchPicture2Change":
        draft.picture2Value = action.picture2Chosen;
        break;
      case "catchPicture3Change":
        draft.picture3Value = action.picture3Chosen;
        break;
      case "catchPicture4Change":
        draft.picture4Value = action.picture4Chosen;
        break;
      case "catchPicture5Change":
        draft.picture5Value = action.picture5Chosen;
        break;
      case "getMap":
        draft.mapInstance = action.mapData;
        break;
      case "changeMarkerPosition":
        draft.markerPosition.lat = action.changeLatitude;
        draft.markerPosition.lng = action.changeLongitude;
        draft.latitudeValue = "";
        draft.longitudeValue = "";
        break;
      case "catchUploadedPictures":
        draft.uploadedPictures = action.picturesChosen;
        break;
      case "changeSendRequest":
        draft.sendRequest = draft.sendRequest + 1;
        break;
      // case "catchUserProfileInfo":
        // draft.userProfile.agencyName = action.profileObject.agency_name;
        // draft.userProfile.phoneNumber = action.profileObject.phone_number;
        // break;
      case "catchUserProfileInfo":
        const { agency_name, phone_number } = action.profileObject || {};
        draft.userProfile.agencyName = agency_name || ""; // Use fallback if undefined
        draft.userProfile.phoneNumber = phone_number || ""; // Use fallback if undefined
        break;
      case "setUserLoggedIn":
        draft.userIsLogged = action.payload;
        break;
      default:
        break;
    }
  }

  const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker) {
          dispatch({
            type: "catchLatitudeChange",
            latitudeChosen: marker.getLatLng().lat,
          });
          dispatch({
            type: "catchLongitudeChange",
            longitudeChosen: marker.getLatLng().lng,
          });
          console.log(marker.getLatLng());
        }
      },
    }),
    [dispatch] // Make sure dispatch is included as a dependency
  );

  function TheMapComponent({ dispatch }) {
    const map = useMap();

    useEffect(() => {
      if (map) {
        dispatch({
          type: 'getMap',
          mapData: map
        });
      }
    }, [map, dispatch]); // Add both map and dispatch as dependencies

    return null;
  }

  useEffect(() => {
    if (state.districtValue === "Abaji Town") {
      state.mapInstance.setView([8.474899735369652, 6.945291984080977], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.474899735369652,
        changeLongitude: 6.945291984080977,
      });
    } else if (state.districtValue === "Agyana/Pandagi") {
      state.mapInstance.setView([8.568913889831025, 6.84784462949272], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.568913889831025,
        changeLongitude: 6.84784462949272,
      });
    } else if (state.districtValue === "Alu/Mamagi") {
      state.mapInstance.setView([8.502118327699886, 6.808714530771005], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.502118327699886,
        changeLongitude: 6.808714530771005,
      });
    } else if (state.districtValue === "Rimba Ebagi") {
      state.mapInstance.setView([8.432797557203628, 6.832776418020598], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.432797557203628,
        changeLongitude: 6.832776418020598,
      });
    } else if (state.districtValue === "Gawu") {
      state.mapInstance.setView([9.210992768763173, 6.848595880678121], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.210992768763173,
        changeLongitude: 6.848595880678121,
      });
    } else if (state.districtValue === "Nuku") {
      state.mapInstance.setView([8.491981058026335, 6.979752816490639], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.491981058026335,
        changeLongitude: 6.979752816490639,
      });
    } else if (state.districtValue === "Apo") {
      state.mapInstance.setView([9.024358591128776, 7.483722230780549], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.024358591128776,
        changeLongitude: 7.483722230780549,
      });
    } else if (state.districtValue === "Asokoro") {
      state.mapInstance.setView([9.048170460363039, 7.5154086061693], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.048170460363039,
        changeLongitude: 7.5154086061693,
      });
    } else if (state.districtValue === "Durumi") {
      state.mapInstance.setView([9.020371092802112, 7.466185100967994], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.020371092802112,
        changeLongitude: 7.466185100967994,
      });
    } else if (state.districtValue === "Garki") {
      state.mapInstance.setView([9.039406448130247, 7.485210464093874], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.039406448130247,
        changeLongitude: 7.485210464093874,
      });
    } else if (state.districtValue === "Guzape") {
      state.mapInstance.setView([9.020223446534219, 7.507406100627792], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.020223446534219,
        changeLongitude: 7.507406100627792,
      });
    } else if (state.districtValue === "Gwarinpa") {
      state.mapInstance.setView([9.115345192047332, 7.402927966731198], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.115345192047332,
        changeLongitude: 7.402927966731198,
      });
    } else if (state.districtValue === "Jabi") {
      state.mapInstance.setView([9.064331260114042, 7.423214738246095], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.064331260114042,
        changeLongitude: 7.423214738246095,
      });
    } else if (state.districtValue === "Jikwoyi") {
      state.mapInstance.setView([8.9670303754112, 7.58029356112024], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.9670303754112,
        changeLongitude: 7.58029356112024,
      });
    } else if (state.districtValue === "Karshi") {
      state.mapInstance.setView([8.8083377228224, 7.5696869027966], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.8083377228224,
        changeLongitude: 7.5696869027966,
      });
    } else if (state.districtValue === "Karu") {
      state.mapInstance.setView([8.994937881824617, 7.571222415700055], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.994937881824617,
        changeLongitude: 7.571222415700055,
      });
    } else if (state.districtValue === "Kaura") {
      state.mapInstance.setView([9.011407469487825, 7.448404264508786], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.011407469487825,
        changeLongitude: 7.448404264508786,
      });
    } else if (state.districtValue === "Lugbe") {
      state.mapInstance.setView([8.968621196105413, 7.369780489914725], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.968621196105413,
        changeLongitude: 7.369780489914725,
      });
    } else if (state.districtValue === "Maitama") {
      state.mapInstance.setView([9.08842815060401, 7.494880137226811], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.08842815060401,
        changeLongitude: 7.494880137226811,
      });
    } else if (state.districtValue === "Mpape") {
      state.mapInstance.setView([9.147965800437891, 7.495011703461003], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.147965800437891,
        changeLongitude: 7.495011703461003,
      });
    } else if (state.districtValue === "Nyanya") {
      state.mapInstance.setView([9.032991541862838, 7.567185201435293], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.032991541862838,
        changeLongitude: 7.567185201435293,
      });
    } else if (state.districtValue === "Utako") {
      state.mapInstance.setView([9.06806576415731, 7.445957325444721], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.06806576415731,
        changeLongitude: 7.445957325444721,
      });
    } else if (state.districtValue === "Wuse") {
      state.mapInstance.setView([9.0750722367138, 7.476586979184618], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.0750722367138,
        changeLongitude: 7.476586979184618,
      });
    } else if (state.districtValue === "Wuye") {
      state.mapInstance.setView([9.05029236266185, 7.443927608956453], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.05029236266185,
        changeLongitude: 7.443927608956453,
      });
    } else if (state.districtValue === "Byazhin") {
      state.mapInstance.setView([9.17126939257039, 7.327323025722113], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.17126939257039,
        changeLongitude: 7.327323025722113,
      });
    } else if (state.districtValue === "Bwari") {
      state.mapInstance.setView([9.285473314810178, 7.378515037610309], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.285473314810178,
        changeLongitude: 7.378515037610309,
      });
    } else if (state.districtValue === "Dei-Dei") {
      state.mapInstance.setView([9.085946338759246, 7.425686860756471], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.085946338759246,
        changeLongitude: 7.425686860756471,
      });
    } else if (state.districtValue === "Dutse") {
      state.mapInstance.setView([11.715477240744516, 9.355960652715773], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 11.715477240744516,
        changeLongitude: 9.355960652715773,
      });
    } else if (state.districtValue === "Dutse Alhaji") {
      state.mapInstance.setView([9.138298714955441, 7.367809597040245], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.138298714955441,
        changeLongitude: 7.367809597040245,
      });
    } else if (state.districtValue === "Igu") {
      state.mapInstance.setView([9.276230001260783, 7.473924379602422], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.276230001260783,
        changeLongitude: 7.473924379602422,
      });
    } else if (state.districtValue === "Kawu") {
      state.mapInstance.setView([9.316508836002972, 7.575275787189904], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.316508836002972,
        changeLongitude: 7.575275787189904,
      });
    } else if (state.districtValue === "Kogo") {
      state.mapInstance.setView([9.258063737623717, 7.387229343968286], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.258063737623717,
        changeLongitude: 7.387229343968286,
      });
    } else if (state.districtValue === "Kubwa") {
      state.mapInstance.setView([9.154674420774802, 7.323323642038905], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.154674420774802,
        changeLongitude: 7.323323642038905,
      });
    } else if (state.districtValue === "Shere") {
      state.mapInstance.setView([9.232711034382044, 7.510380002646841], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.232711034382044,
        changeLongitude: 7.510380002646841,
      });
    } else if (state.districtValue === "Ushafa") {
      state.mapInstance.setView([9.216682068921916, 7.403816256915221], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.216682068921916,
        changeLongitude: 7.403816256915221,
      });
    } else if (state.districtValue === "Zuba") {
      state.mapInstance.setView([9.097674332375579, 7.222493459673684], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.097674332375579,
        changeLongitude: 7.222493459673684,
      });
    }else if (state.districtValue === "Dobi") {
      state.mapInstance.setView([9.060493173484346, 6.993869912136906], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.060493173484346,
        changeLongitude: 6.993869912136906,
      });
    } else if (state.districtValue === "Giri") {
      state.mapInstance.setView([9.016519807929717, 7.154901017203374], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.016519807929717,
        changeLongitude: 7.154901017203374,
      });
    } else if (state.districtValue === "Gwako") {
      state.mapInstance.setView([8.999585377363793, 7.125180596871399], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.999585377363793,
        changeLongitude: 7.125180596871399,
      });
    } else if (state.districtValue === "Gwagwalada Town") {
      state.mapInstance.setView([8.95142055411688, 7.076122270110084], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.95142055411688,
        changeLongitude: 7.076122270110084,
      });
    } else if (state.districtValue === "Ikwa") {
      state.mapInstance.setView([9.122061434969998, 7.117432966437558], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.122061434969998,
        changeLongitude: 7.117432966437558,
      });
    } else if (state.districtValue === "Kutunku") {
      state.mapInstance.setView([8.929396557520862, 7.052943381523085], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.929396557520862,
        changeLongitude: 7.052943381523085,
      });
    } else if (state.districtValue === "Paikon-Kore") {
      state.mapInstance.setView([8.999869986761114, 7.026769260452976], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.999869986761114,
        changeLongitude: 7.026769260452976,
      });
    } else if (state.districtValue === "Tunga Maje") {
      state.mapInstance.setView([9.055922280014956, 7.1928791602390785], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 9.055922280014956,
        changeLongitude: 7.1928791602390785,
      });
    } else if (state.districtValue === "Chibiri") {
      state.mapInstance.setView([8.897744663993807, 7.1822250680269715], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.897744663993807,
        changeLongitude: 7.1822250680269715,
      });
    } else if (state.districtValue === "Gaube") {
      state.mapInstance.setView([8.816790954315703, 7.397053777839727], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.816790954315703,
        changeLongitude: 7.397053777839727,
      });
    } else if (state.districtValue === "Gudunkarya") {
      state.mapInstance.setView([8.495764338017137, 7.344129547104003], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.495764338017137,
        changeLongitude: 7.344129547104003,
      });
    } else if (state.districtValue === "Gwargwada") {
      state.mapInstance.setView([8.467287518170135, 7.1332565284014855], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.467287518170135,
        changeLongitude: 7.1332565284014855,
      });
    } else if (state.districtValue === "Kuje Town") {
      state.mapInstance.setView([8.8821365884365, 7.226851518849652], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.8821365884365,
        changeLongitude: 7.226851518849652,
      });
    } else if (state.districtValue === "Kwaku") {
      state.mapInstance.setView([8.682313342603388, 7.168216561022065], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.682313342603388,
        changeLongitude: 7.168216561022065,
      });
    } else if (state.districtValue === "Rubochi") {
      state.mapInstance.setView([8.53425385292224, 7.036824784086606], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.53425385292224,
        changeLongitude: 7.036824784086606,
      });
    } else if (state.districtValue === "Yangoji") {
      state.mapInstance.setView([8.820351970253816, 7.03397677000956], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.820351970253816,
        changeLongitude: 7.03397677000956,
      });
    } else if (state.districtValue === "Ashara") {
      state.mapInstance.setView([8.671286027678743, 6.854956411054386], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.671286027678743,
        changeLongitude: 6.854956411054386,
      });
    } else if (state.districtValue === "Dafa") {
      state.mapInstance.setView([8.796478823422635, 6.952503196611425], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.796478823422635,
        changeLongitude: 6.952503196611425,
      });
    } else if (state.districtValue === "Gumbo") {
      state.mapInstance.setView([8.711268728441096, 6.983020512829242], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.711268728441096,
        changeLongitude: 6.983020512829242,
      });
    } else if (state.districtValue === "Kilankwa") {
      state.mapInstance.setView([8.864456240427945, 7.099784264635648], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.864456240427945,
        changeLongitude: 7.099784264635648,
      });
    } else if (state.districtValue === "Kundu") {
      state.mapInstance.setView([8.857903846577667, 6.887559934447933], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.857903846577667,
        changeLongitude: 6.887559934447933,
      });
    } else if (state.districtValue === "Kwali Town") {
      state.mapInstance.setView([8.836479802140234, 7.050978607765293], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.836479802140234,
        changeLongitude: 7.050978607765293,
      });
    } else if (state.districtValue === "Pai") {
      state.mapInstance.setView([8.896396894556682, 6.995910357006621], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.896396894556682,
        changeLongitude: 6.995910357006621,
      });
    } else if (state.districtValue === "Sheda") {
      state.mapInstance.setView([8.85707990378606, 7.043342079849546], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.85707990378606,
        changeLongitude: 7.043342079849546,
      });
    } else if (state.districtValue === "Wako") {
      state.mapInstance.setView([8.599135518515768, 6.91457155054666], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.599135518515768,
        changeLongitude: 6.91457155054666,
      });
    } else if (state.districtValue === "Yangoji") {
      state.mapInstance.setView([8.775600001045735, 6.993897010209814], 12);
      dispatch({
        type: "changeMarkerPosition",
        changeLatitude: 8.775600001045735,
        changeLongitude: 6.993897010209814,
      });
    }
  }, [state.districtValue]);

  useEffect(() => {
    if (state.uploadedPictures[0]) {
      dispatch({
        type: "catchPicture1Change",
        picture1Chosen: state.uploadedPictures[0],
      })
    }
  }, [state.uploadedPictures[0]]);

  useEffect(() => {
    if (state.uploadedPictures[1]) {
      dispatch({
        type: "catchPicture2Change",
        picture2Chosen: state.uploadedPictures[1],
      })
    }
  }, [state.uploadedPictures[1]]);

  useEffect(() => {
    if (state.uploadedPictures[2]) {
      dispatch({
        type: "catchPicture3Change",
        picture3Chosen: state.uploadedPictures[2],
      })
    }
  }, [state.uploadedPictures[2]]);

  useEffect(() => {
    if (state.uploadedPictures[3]) {
      dispatch({
        type: "catchPicture4Change",
        picture4Chosen: state.uploadedPictures[3],
      })
    }
  }, [state.uploadedPictures[3]]);

  useEffect(() => {
    if (state.uploadedPictures[4]) {
      dispatch({
        type: "catchPicture5Change",
        picture5Chosen: state.uploadedPictures[4],
      })
    }
  }, [state.uploadedPictures[4]]);
  
  useEffect(()=>{
    async function GetProfileInfo(){
      try {
        const userCookie = Cookies.get('user');  // Ensure the cookie exists
        const userId = userCookie ? JSON.parse(userCookie).user_id : null;
        // console.log(userId)
        const response = await api.get(`${apiUrl}/api/profile/${userId}/`);
        console.log(response.data);
        dispatch({
          type: "catchUserProfileInfo",
          profileObject: response.data
        });
      } catch(e) {
        console.log(e.response);
      }
    }
    GetProfileInfo();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic
    console.log(state); // Test output
    dispatch({type: 'changeSendRequest'});
  };

  useEffect(() => {
    if (state.sendRequest) {
      async function AddProperty() {
        const formData = new FormData();
        const userCookie = Cookies.get('user');  // Ensure the cookie exists
        const userId = userCookie ? JSON.parse(userCookie).user_id : null;
        console.log(userId);
  
        if (!userId) {
          console.error("User ID not found in cookies");
          toast.error("User not authenticated. Please log in.");
          return;
        }
  
        // Ensure latitude and longitude are defined
        if (!state.latitudeValue || !state.longitudeValue) {
            console.error("Latitude or Longitude is not set:", {
                latitude: state.latitudeValue,
                longitude: state.longitudeValue
            });
            toast.error("Please select a location on the map.");
            return;
        }
  
        // Append form data
        formData.append("title", state.titleValue);
        formData.append("description", state.descriptionValue);
        formData.append("area_council", state.areaCouncilValue);
        formData.append("district", state.districtValue);
        formData.append("latitude", state.latitudeValue);
        formData.append("longitude", state.longitudeValue);
        formData.append("listing_type", state.listingTypeValue);
        formData.append("property_status", state.propertyStatusValue);
        formData.append("rental_frequency", state.rentalFrequencyValue);
        formData.append("price", state.priceValue);
        formData.append("rooms", state.roomsValue);
        formData.append("furnished", state.furnishedValue);
        formData.append("pool", state.poolValue);
        formData.append("elevator", state.elevatorValue);
        formData.append("parking", state.parkingValue);
        formData.append("cctv", state.cctvValue);
        formData.append("picture1", state.picture1Value);
        formData.append("picture2", state.picture2Value);
        formData.append("picture3", state.picture3Value);
        formData.append("picture4", state.picture4Value);
        formData.append("picture5", state.picture5Value);
        formData.append("seller", userId);
  
        try {
          const response = await api.post(
            // "http://localhost:8000/api/listings/create/", 
            `${apiUrl}/api/listings/create/`,
            formData
          );
          setIsLoading(false);
          console.log(response.data);
          if (response.status === 201) {
            toast.success("Property added successfully.");
            navigate("/listings");
          }
        } catch (e) {
          setIsLoading(false);
          
          // Error handling: Display specific backend error messages
          if (e.response && e.response.status === 400) {
            console.error("Validation error:", e.response.data);
            toast.error("Validation error. Please check your input.");
  
            // Display specific field errors if available
            const errorData = e.response.data;
            for (let field in errorData) {
              if (errorData[field]) {
                toast.error(`${field}: ${errorData[field].join(', ')}`);
              }
            }
          } else if (e.response && e.response.status === 401) {
            console.error("Unauthorized:", e.response.data);
            toast.error("Unauthorized access. Please log in again.");
          } else if (e.response && e.response.status === 429) {
            console.error("Rate limit exceeded:", e.response.data);
            toast.error("Too many requests. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", e.message);
            toast.error("An unexpected error occurred. Please try again.");
          }
        }
      }
  
      AddProperty();
    }
  }, [state.sendRequest]);

  // worked perfectly, i just wanted to add errors to the above code
  // useEffect(() => {
  //   // const source = Axios.CancelToken.source();
  //   if (state.sendRequest) {
  //     async function AddProperty() {
  //       const formData = new FormData();
  //       // Get userId from cookies using js-cookie
  //       const userCookie = Cookies.get('user');  // Ensure the cookie exists
  //       const userId = userCookie ? JSON.parse(userCookie).user_id : null;
  //       console.log(userId)

  //       // Ensure that userId is defined before proceeding
  //       if (!userId) {
  //         console.error("User ID not found in cookies");
  //         return;
  //       }

  //       // Log latitude and longitude values
  //       console.log("Latitude:", state.latitudeValue, "Longitude:", state.longitudeValue);

  //       // Ensure latitude and longitude are defined
  //       if (!state.latitudeValue || !state.longitudeValue) {
  //           console.error("Latitude or Longitude is not set:", {
  //               latitude: state.latitudeValue,
  //               longitude: state.longitudeValue
  //           });
  //           return;
  //       }

  //       // Append each form data correctly with two arguments
  //       formData.append("title", state.titleValue);
  //       formData.append("description", state.descriptionValue);
  //       formData.append("area_council", state.areaCouncilValue);
  //       formData.append("district", state.districtValue);
  //       formData.append("latitude", state.latitudeValue);
  //       formData.append("longitude", state.longitudeValue);
  //       formData.append("listing_type", state.listingTypeValue);
  //       formData.append("property_status", state.propertyStatusValue);
  //       formData.append("rental_frequency", state.rentalFrequencyValue);
  //       formData.append("price", state.priceValue);
  //       formData.append("rooms", state.roomsValue);
  //       formData.append("furnished", state.furnishedValue);
  //       formData.append("pool", state.poolValue);
  //       formData.append("elevator", state.elevatorValue);
  //       formData.append("parking", state.parkingValue);
  //       formData.append("cctv", state.cctvValue);
  //       formData.append("latitude", state.latitudeValue);
  //       formData.append("longitude", state.longitudeValue);
  //       formData.append("picture1", state.picture1Value);
  //       formData.append("picture2", state.picture2Value);
  //       formData.append("picture3", state.picture3Value);
  //       formData.append("picture4", state.picture4Value);
  //       formData.append("picture5", state.picture5Value);
  //       formData.append("seller", userId);

  //       try {
  //         const response = await api.post(
  //           "http://localhost:8000/api/listings/create/", 
  //           formData
  //           // {
  //           //   cancelToken: source.token
  //           // }
  //         );
  //         setIsLoading(false);
  //         console.log(response.data);
  //         if (response.status === 201) {
  //           toast.success("Property added successfully.");
  //         }
  //         navigate("/listings");
  //       } catch (e) {
  //         console.log(e.response);
  //       }
        
  //     }
  //     AddProperty();
  //   }
  // }, [state.sendRequest]);
  
  function priceDisplay() {
    if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Day") {
      return "Price Per Day";
    }
    else if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Weekly") {
      return "Price Per Week";
    }
    else if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Month") {
      return "Price Per Month";
    }
    else if (state.propertyStatusValue === "Rent" && state.rentalFrequencyValue === "Year") {
      return "Price Per Year";
    }
    else {
      return "Price";
    }
  }

  useEffect(() => {
    const userCookie = Cookies.get('user');
    if (userCookie) {
      const user = JSON.parse(userCookie);
      // console.log('User Cookie:', user);
      
      if (user.profile) {
        console.log('Profile found:', user.profile);
        dispatch({ type: 'catchUserProfileInfo', profileObject: user.profile });
        dispatch({ type: 'setUserLoggedIn', payload: true });
      } else {
        console.warn("Profile data is not available in user cookie.");
        dispatch({ type: 'setUserLoggedIn', payload: true });
      }
    } else {
      console.warn("User cookie is not found.");
      dispatch({ type: 'setUserLoggedIn', payload: false });
    }
  }, [dispatch]);  
  
  function SubmitButtonDisplay() {
    const { agencyName, phoneNumber } = state.userProfile;
  
    // Check if the user is logged in
    if (!state.userIsLogged) {
      return (
        <Button
          type="submit"
          onClick={() => navigate('/login')}
          variant="contained"
          style={{ marginBottom: '0.5rem' }}
          color="primary"
          fullWidth
        >
          Sign In To Add a Property
        </Button>
      );
    } 
    // Check if the user profile is complete
    if (agencyName && phoneNumber) {
      return (
        <Button
          type="submit"
          variant="contained"
          style={{ marginBottom: '0.5rem' }}
          color="primary"
          fullWidth
        >
          Submit
        </Button>
      );
    } else {
      return (
        <Button
          type="submit"
          onClick={() => navigate('/profile')}
          variant="contained"
          style={{ marginBottom: '0.5rem' }}
          color="primary"
          fullWidth
        >
          Complete Your Profile
        </Button>
      );
    }
  }  

  if (isLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Header />
      <Box display="flex" justifyContent="center" alignItems="center" mt={1.5} mb={1}>
        <HomeIcon fontSize="large" />
        <Typography variant="h4" ml={1}>
          Add A New Property
        </Typography>
      </Box>
      <Container maxWidth="sm">
        <form onSubmit={handleSubmit}>
          {/* Title Field */}
          <TextField
            label="Title"
            value={state.titleValue}
            onChange={(e) =>
              dispatch({
                type: "catchTitleChange",
                titleChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />
          {/* Description Field */}
          <TextField
            label="Description"
            value={state.descriptionValue}
            onChange={(e) =>
              dispatch({
                type: "catchDescriptionChange",
                descriptionChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            multiline
            rows={4}
            required
          />
          {/* Area Council Dropdown */}
          <TextField
            select
            label="Area Council"
            value={state.areaCouncilValue}
            onChange={(e) =>
              dispatch({
                type: "catchAreaCouncilChange",
                areaCouncilChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          >
            {areaCouncilOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          {/* District Field */}
          <TextField
            select
            label="District"
            value={state.districtValue}
            onChange={(e) =>
              dispatch({
                type: "catchDistrictChange",
                districtChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          >
            {state.areaCouncilValue === "Abaji" &&
              abajiOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
            {state.areaCouncilValue === "AMAC" &&
              amacOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
            {state.areaCouncilValue === "Bwari" &&
              bwariOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
            {state.areaCouncilValue === "Gwagwalada" &&
              gwagwaladaOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
            {state.areaCouncilValue === "Kuje" &&
              kujeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
            {state.areaCouncilValue === "Kwali" &&
              kwaliOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
          </TextField>
          <Grid item container style={{height: "35rem", marginTop: "0.5rem", marginBottom: "1rem"}}>
            <MapContainer center={[9.0765, 7.3986]} zoom={13} scrollWheelZoom={true}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <TheMapComponent dispatch={dispatch} />
              <Marker
                draggable
                eventHandlers={eventHandlers}
                position={state.markerPosition}
                ref={markerRef}>
              </Marker>
            </MapContainer>
          </Grid>
          {/* Listing Type Dropdown */}
          <TextField
            select
            label="Listing Type"
            value={state.listingTypeValue}
            onChange={(e) =>
              dispatch({
                type: "catchListingTypeChange",
                listingTypeChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          >
            {[
              { value: 'House', label: 'House' },
              { value: 'Office', label: 'Office' },
              { value: 'Apartment', label: 'Apartment' }
            ].map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Property Status Dropdown */}
          <TextField
            select
            label="Property Status"
            value={state.propertyStatusValue}
            onChange={(e) =>
              dispatch({
                type: "catchPropertyStatusChange",
                propertyStatusChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          >
            {[
              { value: 'Sale', label: 'Sale' },
              { value: 'Rent', label: 'Rent' }
            ].map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Rental Frequency Dropdown */}
          <TextField
            select
            label="Rental Frequency"
            value={state.rentalFrequencyValue}
            onChange={(e) =>
              dispatch({
                type: "catchRentalFrequencyChange",
                rentalFrequencyChosen: e.target.value,
              })
            }
            variant="outlined"
            disabled={state.propertyStatusValue === 'Sale' ? true : false}
            margin="normal"
            fullWidth
          >
            {[
              { value: 'Day', label: 'Day' },
              { value: 'Weekly', label: 'Weekly' },
              { value: 'Month', label: 'Month' },
              { value: 'Year', label: 'Year' }
            ].map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Price Field */}
          <TextField
            label={priceDisplay()}
            type="number"
            value={state.priceValue}
            onChange={(e) =>
              dispatch({
                type: "catchPriceValueChange",
                priceChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />

          {/* Rooms Field */}
          {state.listingTypeValue === "Office" ? (
            ""
          ) : (
            <TextField
            label="Rooms"
            type="number"
            value={state.roomsValue}
            onChange={(e) =>
              dispatch({
                type: "catchRoomsValueChange",
                roomsChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />
          )}

          {/* Checkboxes for Booleans */}
          <FormControlLabel
            control={
              <Checkbox
                checked={state.furnishedValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchFurnishedChange",
                    furnishedChosen: e.target.checked,
                  })
                }
              />
            }
            label="Furnished"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.poolValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchPoolChange",
                    poolChosen: e.target.checked,
                  })
                }
              />
            }
            label="Pool"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.elevatorValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchElevatorChange",
                    elevatorChosen: e.target.checked,
                  })
                }
              />
            }
            label="Elevator"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.parkingValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchParkingChange",
                    parkingChosen: e.target.checked,
                  })
                }
              />
            }
            label="Parking"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={state.cctvValue}
                onChange={(e) =>
                  dispatch({
                    type: "catchCctvChange",
                    cctvChosen: e.target.checked,
                  })
                }
              />
            }
            label="CCTV"
          />
          {/* Submit Button */}
          {/* <Button onClick={() =>
            console.log(state.uploadedPictures)
          }> Test Button</Button> */}
          <Button component='label' variant="contained" style={{marginTop: "0.5rem", marginBottom: "0.5rem"}} color="primary" fullWidth>
            UPLOAD PICTURES (MAX 5)
            <input
            type='file'
            multiple
            accept='image/png, image/gif, image/jpeg'
            hidden
            onChange={(e) =>
              dispatch({
                type: 'catchUploadedPictures',
                picturesChosen: e.target.files,
              })
            }
            />
          </Button>
          <Grid item container>
            <ul>
              {state.picture1Value ? <li> {state.picture1Value.name} </li> : ""}
              {state.picture2Value ? <li> {state.picture2Value.name} </li> : ""}
              {state.picture3Value ? <li> {state.picture3Value.name} </li> : ""}
              {state.picture4Value ? <li> {state.picture4Value.name} </li> : ""}
              {state.picture5Value ? <li> {state.picture5Value.name} </li> : ""}
            </ul>
          </Grid>
          {/* <Button type="submit" variant="contained" style={{marginBottom: "0.5rem"}} color="primary" fullWidth>
            Submit
          </Button> */}
          {SubmitButtonDisplay()}
        </form>
      </Container>
    </>
  );
}

export default AddProperty;